<template>
  <sideBarView />

  <navbarView />

  <main class="main-sec" id="main">
    <div class="container">
      <div class="flex-bet-main mb-2">
        <div class="side-heading">
          <h6>
            <router-link to="/" class="black">{{ $t('ownerDetails.owners') }}</router-link> /
            <span class="color-main">{{ $t('ownerDetails.ownerDetails') }}</span>
          </h6>
          <p class="font13 gray-col">{{ $t('ownerDetails.ownerDetailsDescription') }}</p>
        </div>
        <div class="flex-sm-gap def-wid">
          <router-link
            class="main-btn lg up"
            :to="{ name: 'editOwner', params: { id: route.params.id } }"
          >
            {{ $t('ownerDetails.editOwnerData') }}
          </router-link>
          <button
            class="main-btn up lg bg-red"
            type="button"
            @click="confirmRemove = true"
          >
            {{ $t('ownerDetails.deleteOwner') }}
          </button>
        </div>
      </div>

      <div class="card-details-def mb-3">
        <h6 class="color-main mb-4">{{ $t('ownerDetails.ownerData') }}</h6>
        <div class="flex-bet-main">
          <div class="flex-sm-gap mb-3">
            <img :src="ownerImg" class="img-user" alt="" />
            <div class="user-data-card">
              <div class="color-main mb-2">
                {{ name }}
              </div>
              <div class="flex-sm-gap bigger-gap">
                <a
                  :href="'tel:' + ownerPhone"
                  target="_blank"
                  class="phone-info black"
                >
                  <div class="phone-icon">
                    <i class="fa-solid fa-phone"></i>
                  </div>
                  {{ ownerPhone }}
                </a>

                <!-- <div class="phone-info black">
                  <div class="phone-icon">
                    <i class="fa-solid fa-map-pin"></i>
                  </div>
                  {{ ownerLocation }}
                </div> -->
                <a :href="'mailto:' + ownerEmail" class="phone-info black">
                  <div class="phone-icon">
                    <i class="fa-solid fa-envelope"></i>
                  </div>
                  {{ ownerEmail }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-bet-main mb-2">
        <div class="font17 color-main">{{ $t('ownerDetails.buildings') }} ({{ buildings.length }})</div>
        <router-link
          :to="{ name: 'addBuilding', params: { id: ownerId } }"
          class="plusSmBtn up"
        >
          <i class="fa-solid fa-plus"></i>
        </router-link>
      </div>
      <div
        class="card-details-def mb-3 shadow-main"
        v-for="building in buildings"
        :key="building.id"
      >
        <div class="flex-bet-main mb-3">
          <h6 class="black">
            {{ $t('ownerDetails.buildingName') }}:<span>{{ building.name }}</span>
          </h6>
          <h6 class="gray-col font14">
            {{ $t('ownerDetails.buildingType') }}:<span class="color-main">{{ building.type.name }}</span>
          </h6>
        </div>
        <h6 class="gray-col font14">
          {{ $t('ownerDetails.buildingCode') }}:<span class="color-main">#{{ building.ref_code }}</span>
        </h6>
      </div>
    </div>
  </main>

  <!-- confirm modal  -->
  <Dialog v-model:visible="confirmRemove" modal :style="{ width: '520px' }">
    <div class="modal-body-main modal-pad">
      <div class="flex-group-me mb-4 mt-3">
        <img :src="dangerImg" class="successImg" alt="" />
      </div>
      <h6 class="font-bold text-center black font17 mb-4">
        {{ $t('ownerDetails.confirmDeleteOwner') }}
      </h6>
      <div class="flex-group-me mb-3">
        <button
          type="button"
          :disabled="disabled"
          class="main-btn lg up bg-red"
          @click="removeOwner"
        >
          <div v-if="!disabled">{{ $t('ownerDetails.yesDelete') }}</div>
          <div class="loading" role="status" v-if="disabled">
            {{ $t('ownerDetails.deleting') }}
            <div class="spinner-small-white" v-if="disabled"></div>
          </div>
        </button>
        <button
          type="button"
          class="main-btn lg up bg-trans"
          @click="confirmRemove = false"
        >
          {{ $t('ownerDetails.cancel') }}
        </button>
      </div>
    </div>
  </Dialog>
  <!-- success modal  -->
  <Dialog v-model:visible="suceessRemove" modal :style="{ width: '520px' }">
    <div class="modal-body-main modal-pad">
      <div class="flex-group-me mb-4 mt-3">
        <img :src="successImg" class="successImg" alt="" />
      </div>
      <h6 class="font-bold text-center black font17 mb-4">
        {{ $t('ownerDetails.ownerDeletedSuccess') }}
      </h6>
      <div class="flex-group-me mb-3">
        <router-link to="/ownersView" class="main-btn lg up"
          >{{ $t('ownerDetails.owners') }}</router-link
        >
        <router-link to="/dashboardHome" class="main-btn lg up bg-trans"
          >{{ $t('ownerDetails.home') }}</router-link
        >
      </div>
    </div>
  </Dialog>
</template>

<script setup>
// imports
import sideBarView from "../components/dashboard/sideBarView.vue";
import navbarView from "../components/dashboard/navbarView.vue";

import Dialog from "primevue/dialog";

import { ref, onMounted } from "vue";
const route = useRoute();
import { useRoute } from "vue-router";
import { useRouter } from "vue-router";
const router = useRouter();
const toast = useToast();
import { useToast } from "primevue/usetoast";
import axios from "axios";

// reactive state

const successImg = ref(require("../assets/imgs/check.png"));
const dangerImg = ref(require("../assets/imgs/noun_warning.png"));
const suceessRemove = ref(false);
const confirmRemove = ref(false);
const disabled = ref(false);

// ref details
const ownerId = ref(null);
const ownerImg = ref("");
const name = ref("");
const ownerPhone = ref("");
const ownerLocation = ref("");
const ownerEmail = ref("");
const buildings = ref([]);

// functions
function getOwner() {
  axios
    .get(`/manager/owner-details/${route.params.id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      ownerId.value = response.data.data.owner.id;
      name.value = response.data.data.owner.name;
      ownerPhone.value = response.data.data.owner.phone;
      ownerImg.value = response.data.data.owner.image;
      ownerLocation.value = response.data.data.owner.city;
      ownerEmail.value = response.data.data.owner.email;
      buildings.value = response.data.data.buildings;
    });
}
function removeOwner() {
  disabled.value = true;
  // const fd = new FormData();

  axios
    .delete(`manager/delete-owner/${route.params.id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      if (response.data.key == "success") {
        suceessRemove.value = true;
        confirmRemove.value = false;
        setTimeout(function () {
          router.push("/ownersView");
        }, 1500);
      } else {
        toast.add({
          severity: "error",
          detail: `${response.data.msg}`,
          life: 3000,
        });
      }
      disabled.value = false;
    });
}

// lifecycle hooks
onMounted(() => {
  getOwner();
});
</script>
